(function () {
    'use strict';

    var module = angular.module('uwAgenda.tasks');
    module.controller('TaskReactionAddController', ['TaskService', 'DateService', '$translate', 'Alert', '$rootScope', '$uibModalStack', 'TaskStateEnum', 'FlagTypeEnum', 'SharedAgendaService', 'CallsService',
        function (TaskService, DateService, $translate, Alert, $rootScope, $uibModalStack, TaskStateEnum, FlagTypeEnum, SharedAgendaService, CallsService) {
            var vm = this;

            // current user
            vm.currentUser = SharedAgendaService.getLoggedInUserData();
            vm.isRingfoon = false;
            // current reaction
            vm.reaction = {
                content: '',
                flag: null
            };

            vm.taskState = -1;
            vm.isImportant = false;

            // full or min summernote
            vm.summernoteToolbar = 'min';

            activate();

            vm.flagChanged = function(flagValue) {
                // If we change to a Flag, 
                // that task state must be "FollowUpByOperator"
                if (flagValue || flagValue === FlagTypeEnum.Move.value) {
                    vm.taskState = TaskStateEnum.FollowUpByOperator.value;                    
                }
            }

            /* check flags after adding of context-content */
            vm.checkFlags = function (content) {
                if (content === undefined || content === null) { return; }
                // find
                if (content.indexOf('@@MOVE') !== -1) {
                    // move flag
                    vm.reaction.flag = FlagTypeEnum.Move.value;
                } //if
                else if (content.indexOf('@@GOOD') !== -1) {
                    // good flag
                    vm.reaction.flag = FlagTypeEnum.Good.value;
                } // else if
                else if (content.indexOf('@@INFO') !== -1) {
                    // info flag
                    vm.reaction.flag = FlagTypeEnum.Info.value;
                } // else if
                else if (content.indexOf('@@WARNING') !== -1) {
                    // warning flag
                    vm.reaction.flag = FlagTypeEnum.Warning.value;
                } // else if
            };


            /* abort making comments -> close div */
            vm.abort = function () {
                // reset
                vm.reaction.content = '';
                vm.reaction.flag = null;
            };


            /* save new task reaction */
            vm.save = function (pin) {

                /// Either save new reaction if text is available 
                /// Otherwise just update state / flags

                // is content available ?
                if (!vm.reaction.content || vm.reaction.content === '') {
                    /// just update state and flag
                    return state(pin);
                } // if

                // new reaction object
                var reaction = {
                    content: vm.reaction.content,
                    deleted: false,
                    fk_Task: vm.task.id,
                    fk_User: vm.currentUser.id,
                    flag: vm.reaction.flag,
                    callGuid: null,
                    callerNumber: null,
                    isImportant: vm.isImportant
                };
                
                if (pin)
                {
                    reaction.pinToDate = DateService.data.date;
                }

                // call guid and number if available (concat)
                CallsService.setGuidToEntity(reaction);

                // save new reaction
                TaskService.newReaction(vm.task.id, vm.taskState, reaction, pin).then(function (result) {
                    Alert.success($translate.instant('note_added'));
                    const div = document.querySelector('.list-container-part ul')
                    div.scroll({
                        top: 0,
                        behavior: 'smooth'
                    });
                });
            };

            // update state
            function state(pin) {
                // update Task - State - isImportant !!! if needed
                if (vm.task.taskState !== vm.taskState || vm.task.flag !== vm.reaction.flag || vm.task.isImportant !== vm.isImportant) {
                    const div = document.querySelector('.list-container-part ul')
                    div.scroll({
                        top: 0,
                        behavior: 'smooth'
                    });
                    // also update task-state
                    return TaskService.state(vm.task.id, vm.taskState, vm.reaction.flag, pin, DateService.data.date, vm.isImportant);
                } // if 

                // close modal if existing
                if ($uibModalStack) { $uibModalStack.dismissAll(); }
                return;
            }


            /* activation work */
            function activate() {
                // model for changing task state
                vm.taskState = vm.task.taskState;
                // model for flag state
                vm.reaction.flag = vm.task.flag;

                vm.isRingfoon = $rootScope.isRingfoon;
                
                //model to track isImportant toggle
                vm.isImportant = vm.task.isImportant;

                if ($rootScope.isRingfoon) {
                    vm.summernoteToolbar = 'full';
                } // if

                // only if Daytask
                if (vm.task.isToDo === false) {

                    if ($rootScope.isRingfoonOperator) {
                        // if operator writes comment to daytask -> status will automatic be "inProgress",
                        // unless the Flag is set, then don't change the task state
                        if (!vm.task.flag) {
                            vm.taskState = TaskStateEnum.InProgress.value;
                        }
                    } //if
                    else if ($rootScope.isRingfoon) {
                        // if superadmin writes comment to daytask -> status will automatic be "follow up by operator"
                        vm.taskState = TaskStateEnum.FollowUpByOperator.value;
                    } // else if
                    else {
                        // if no ringfoon user writes comment to daytask -> status will automatic be "follow up by operator" -> if secretary licence
                        if (SharedAgendaService.currentUser().isSecretaryLicence === true) {
                            vm.taskState = TaskStateEnum.FollowUpByOperator.value;
                        } //if
                        else {
                            vm.taskState = TaskStateEnum.InProgress.value;
                        } // else
                    } // else
                } // if
            }
        }]);
})();
